<ng-container *transloco="let t; read: 'user'">
  <div class="p-5">
    <h1 class="pb-2 text-3xl">{{ t('manageEnrollment.viewChildAssessments.pageTitle') }}</h1>
    <drdp-add-edit-table [dataSource]="dataSource" [tableData]="tableData" [columns]="tableColumns"
      (actionIconClicked)="onIconClick($event)">
    </drdp-add-edit-table>
  </div>
</ng-container>